        // Cart functionality
        let cartCount = 0;
        const cartCountElement = document.getElementById('cartCount');
        const successMessage = document.getElementById('successMessage');
        const successText = document.getElementById('successText');

        // Add to cart functionality
        document.querySelectorAll('.add-to-cart').forEach(button => {
            button.addEventListener('click', function() {
                const product = this.getAttribute('data-product');
                const price = this.getAttribute('data-price');
                
                // Update cart count
                cartCount++;
                cartCountElement.textContent = cartCount;
                
                // Show success message with golden coins
                const coins = Math.floor(price * 10);
                successText.innerHTML = `🎉 ${product} added! +${coins} golden coins earned! ⭐`;
                successMessage.classList.add('show');
                
                // Add celebration effect
                createCelebrationEffect(this);
                
                // Hide success message after 4 seconds
                setTimeout(() => {
                    successMessage.classList.remove('show');
                }, 4000);
            });
        });

        // Create celebration effect
        function createCelebrationEffect(button) {
            const emojis = ['⭐', '🌟', '✨', '🪙', '💫'];
            for (let i = 0; i < 5; i++) {
                setTimeout(() => {
                    const emoji = document.createElement('div');
                    emoji.textContent = emojis[Math.floor(Math.random() * emojis.length)];
                    emoji.style.position = 'absolute';
                    emoji.style.fontSize = '1.5rem';
                    emoji.style.pointerEvents = 'none';
                    emoji.style.zIndex = '1000';
                    emoji.style.left = (button.getBoundingClientRect().left + Math.random() * 100) + 'px';
                    emoji.style.top = (button.getBoundingClientRect().top + Math.random() * 50) + 'px';
                    emoji.style.animation = 'float 2s ease-out forwards';
                    document.body.appendChild(emoji);
                    
                    setTimeout(() => {
                        document.body.removeChild(emoji);
                    }, 2000);
                }, i * 100);
            }
        }

        // Smooth scrolling
        document.querySelectorAll('a[href^="#"]').forEach(anchor => {
            anchor.addEventListener('click', function (e) {
                e.preventDefault();
                const target = document.querySelector(this.getAttribute('href'));
                if (target) {
                    target.scrollIntoView({
                        behavior: 'smooth'
                    });
                }
            });
        });

        // Newsletter form
        document.querySelector('.newsletter-form').addEventListener('submit', function(e) {
            e.preventDefault();
            successText.innerHTML = '🎉 Thanks for subscribing! Welcome to the cosmic adventure! +100 bonus coins! ⭐';
            successMessage.classList.add('show');
            this.reset();
            
            setTimeout(() => {
                successMessage.classList.remove('show');
            }, 4000);
        });

        // Add floating animation keyframes
        const style = document.createElement('style');
        style.textContent = `
            @keyframes celebrationFloat {
                0% { transform: translateY(0) scale(1); opacity: 1; }
                100% { transform: translateY(-100px) scale(0.5); opacity: 0; }
            }
        `;
        document.head.appendChild(style);
